/* import __COLOCATED_TEMPLATE__ from './list-item.hbs'; */
import Component from '@glimmer/component';

export default class PlaylistListItemComponent extends Component {}
